module.exports = __webpack_public_path__ + "static/media/bøtte.24ec3a79.m4a";